// @flow
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

// Material
import Container from '@material-ui/core/Container';

const FooterWrapper = styled.footer`
  background-color: var(--color-brand-highlight);
  color: var(--color-neutral-white);
  padding: 24px 0;
`;

const FooterNav = styled.nav`
  a {
    padding: 0 0.5rem;
  }

  a:first-child {
    padding-left: 0;
  }
`;

const FooterRight = styled.div``;

const Footer = () => {
  const copyright = new Date().getFullYear();

  return (
    <FooterWrapper>
      <Container style={{ display: 'flex', justifyContent: 'space-between' }}>
        <FooterNav>
          <Link to="/" title="Naexguide Home">
            Naexguide
          </Link>
          <Link to="/about" title="About Naexguide">
            About
          </Link>
          <Link to="/terms" title="Terms">
            Terms
          </Link>
          <Link to="/privacy-policy" title="Privacy policy">
            Privacy policy
          </Link>
        </FooterNav>
        <FooterRight>&copy; {copyright} Naexguide </FooterRight>
      </Container>
    </FooterWrapper>
  );
};

export default Footer;
